import * as Yup from "yup";

const Validation = Yup.object({
  languageId: Yup.string().required("Please select Language!"),
  question: Yup.string().required("Please enter Question!"),
  answer: Yup.string().required("Please enter Answer!"),
});

export default Validation;
